import Select from "./Select";

export default {
  select: Select,
};
